import * as React from 'react'

interface BeforeAfterIconProps {
  size?: number
  color?: string
}

const SVGComponent = ({ size = 24, color = '#1A1A1A', ...props }: BeforeAfterIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1C12.5523 1 13 1.44772 13 2V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V21.0605H7.87988C5.18505 21.0605 3.00004 18.8755 3 16.1807V7.87988C3.00009 5.18509 5.18509 3.00009 7.87988 3H11V2C11 1.44772 11.4477 1 12 1ZM16.1504 3C18.8453 3 21.0303 5.18495 21.0303 7.87988V16.1807C21.0302 18.8756 18.8453 21.0605 16.1504 21.0605C15.5983 21.0605 15.1506 20.6126 15.1504 20.0605C15.1504 19.5083 15.5982 19.0606 16.1504 19.0605C17.7407 19.0605 19.0302 17.771 19.0303 16.1807V7.87988C19.0303 6.28952 17.7408 5 16.1504 5C15.5982 4.99993 15.1504 4.55224 15.1504 4C15.1504 3.44776 15.5982 3.00007 16.1504 3Z"
      fill={color}
    />
  </svg>
)
export default SVGComponent

